import React from 'react';
import { Layers, Minus, Plus } from 'lucide-react';
import NumericInput from './NumericInput';

const BulkAddModal = ({
  showBulkAddModal,
  setShowBulkAddModal,
  bulkScreenCount,
  setBulkScreenCount,
  screensLength,
  addBulkScreens
}) => {
  if (!showBulkAddModal) return null;

  return (
    <div className="fixed inset-0 bg-gray-950/40 dark:bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="max-w-md w-full overflow-hidden rounded-xl bg-white shadow-overlay ring-1 ring-gray-900/5 dark:bg-gray-800 dark:ring-white/10">
        <div className="flex items-start justify-between gap-4 border-b border-gray-100 px-6 py-4 dark:border-white/[0.06]">
          <div className="flex min-w-0 items-center gap-2.5">
            <Layers className="h-5 w-5 flex-shrink-0 text-gray-400" />
            <h2 className="text-base font-semibold text-gray-900 dark:text-gray-50">Add Multiple Screens</h2>
          </div>
        </div>

        <div className="px-6 py-5">
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
            Quickly add multiple blank screens to your assessment at once.
          </p>

          <div>
            <label className="label">
              Number of screens to add
            </label>
            <div className="flex items-center gap-2">
              <button
                onClick={() => setBulkScreenCount(Math.max(1, bulkScreenCount - 1))}
                className="btn btn-secondary btn-icon"
              >
                <Minus className="w-4 h-4" />
              </button>
              
              <NumericInput
                min={1}
                max={50}
                value={bulkScreenCount}
                fallback={1}
                onChange={(val) => setBulkScreenCount(val)}
                className="input h-9 flex-1 text-center text-base font-semibold tabular-nums"
              />

              <button
                onClick={() => setBulkScreenCount(Math.min(50, bulkScreenCount + 1))}
                className="btn btn-secondary btn-icon"
              >
                <Plus className="w-4 h-4" />
              </button>
            </div>
            <p className="hint">Maximum: 50 screens</p>
          </div>

          <div className="mt-4 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 dark:border-white/[0.06] dark:bg-white/[0.02]">
            <p className="text-sm text-gray-600 dark:text-gray-300">
              <strong>Preview:</strong> Will create{' '}
              <strong className="text-gray-900 dark:text-gray-100">
                Screen {screensLength + 1} - Screen {screensLength + bulkScreenCount}
              </strong>
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-end gap-2 border-t border-gray-100 bg-gray-50/70 px-6 py-3.5 dark:border-white/[0.06] dark:bg-white/[0.02]">
          <button
            onClick={() => {
              setShowBulkAddModal(false);
              setBulkScreenCount(5);
            }}
            className="btn btn-secondary"
          >
            Cancel
          </button>
          <button
            onClick={() => addBulkScreens(bulkScreenCount)}
            className="btn btn-primary"
          >
            <Layers className="w-4 h-4" />
            Add {bulkScreenCount} Screen{bulkScreenCount !== 1 ? 's' : ''}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkAddModal;
